import { useSyncExternalStore } from "react";

/**
 * Vrai quand la requête média correspond (ex. « (min-width: 1024px) »).
 * Sans `matchMedia` (tests, très vieux navigateurs) : faux.
 */
export function useMediaQuery(query: string): boolean {
  return useSyncExternalStore(
    (onChange) => {
      if (typeof window.matchMedia !== "function") return () => {};
      const mql = window.matchMedia(query);
      mql.addEventListener("change", onChange);
      return () => mql.removeEventListener("change", onChange);
    },
    () =>
      typeof window.matchMedia === "function" &&
      window.matchMedia(query).matches,
    () => false,
  );
}
